
import { Inject, Injector, AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent, Subject, Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/user-service';
import { UserServiceImpl } from 'src/app/service/impl/user-service-impl';
import { HomeViewModel } from 'src/app/routes/home/home-view-model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, AfterViewInit {

  userFormGroup: FormGroup;
  homeViewModel: HomeViewModel = this.injector.get(HomeViewModel);
  userService: UserService = this.injector.get(UserService);
  user: User;
  

  public clickStream$: Subject<any> = new Subject<any>();
  public submitStream$: Subject<any> = new Subject<any>();
 
  constructor(private injector: Injector, private fb: RxFormBuilder) {
    this.user = this.userService.getUser();
    this.userFormGroup = this.fb.formGroup(this.user);
    // try {
    //   this.user.email = "email@email";
    // } catch (error) {
    //     console.info(error);
    // }

  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const parent = this;
   
    const observer = {
      next(user) {
        console.log('=======>' + user);
        parent.user.name = user.title;
      }
    };

    this.homeViewModel.input.viewClick = this.clickStream$;
    this.homeViewModel.input.submitClick = this.submitStream$;
    this.homeViewModel.output.userSubject.subscribe(observer);

    if (this.homeViewModel.setup() === false) {
      throw new Error('example error message');
    }
    
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    this.submitStream$.next(this.user);
    console.warn(this.userFormGroup.value);
  }
  
}
